import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';
import { dumpIvaFolder } from 'lib/api';
import CustomButton from 'lib/designSystem/Button';
import Uploader from 'lib/designSystem/Uploader';
import React, { ChangeEvent, useState } from 'react';
import { useParams } from 'react-router-dom';
import { AnyAction, Dispatch } from 'redux';

interface IvaEmptyerProps {
  setLoading: (loading: boolean) => void;
  dispatch: Dispatch<AnyAction>;
  activateSuccess: (message: string) => void;
  setOpenIVADialog: (open: boolean) => void;
  activateFailed: (message: string) => void;
  openIVADialog: boolean;
  fetchRelations: () => Promise<void>;
}

function IvaEmptyer(props: IvaEmptyerProps) {
  const {
    setLoading,
    dispatch,
    activateSuccess,
    activateFailed,
    setOpenIVADialog,
    openIVADialog,
    fetchRelations,
  } = props;
  const [uploadedFileName, setUploadedFileName] = useState<string | null>(null);
  const [fileBase64, setFileBase64] = useState<string | null>(null);
  const { id } = useParams<{ id: string }>();

  const handleFileChange = (event: ChangeEvent<HTMLInputElement>) => {
    try {
      const uploadedFile = event.target.files?.[0];
      if (!uploadedFile) return;

      if (uploadedFile.type !== 'application/pdf') {
        activateFailed('Por favor, sube un archivo PDF válido.');
        return;
      }

      setUploadedFileName(uploadedFile.name);

      const reader = new FileReader();
      reader.onload = () => {
        const base64 = (reader.result as string).split(',')[1];
        setFileBase64(base64);
      };
      reader.readAsDataURL(uploadedFile);
    } catch (error) {
      activateFailed(
        'Ha ocurrido un error al subir el PDF. Intentelo nuevamente',
      );
    }
  };

  const handleSubmit = async () => {
    setLoading(true);
    if (!id) {
      alert('No se ha encontrado el id de la empresa');
      return;
    }
    if (!fileBase64) {
      activateFailed('Por favor, sube un archivo PDF.');
      return;
    }
    try {
      await dumpIvaFolder(dispatch, id, fileBase64);
      await fetchRelations();
      activateSuccess('Se ha terminado de vaciar el documento tributario.');
    } catch (error) {
      console.error(error);
      activateFailed(
        'No se pudo vaciar el documento tributario. Intenta nuevamente.',
      );
    }
    setOpenIVADialog(false);
    setFileBase64(null);
    setLoading(false);
  };

  return (
    <Dialog
      open={openIVADialog}
      onClose={() => {
        setOpenIVADialog(false);
        setFileBase64(null);
      }}
    >
      <DialogTitle>
        <b>Vaciado IVA</b>
      </DialogTitle>
      <DialogContent style={{ maxWidth: 300 }}>
        <Uploader
          handleFileChange={handleFileChange}
          buttonText="Agregar PDF"
          uploadedFileName={uploadedFileName}
        />
        <Typography>
          <b>Importante</b> Si este cliente ya tiene un vaciado, este va a
          reemplazarlo.
        </Typography>
      </DialogContent>
      <DialogActions>
        <CustomButton
          onClick={() => {
            setOpenIVADialog(false);
            setFileBase64(null);
          }}
          color="secondary"
        >
          Cancelar
        </CustomButton>
        <CustomButton onClick={handleSubmit} color="primary">
          Guardar
        </CustomButton>
      </DialogActions>
    </Dialog>
  );
}

export default IvaEmptyer;
